export default {
  ContainerPaddingInline: "--container-padding-inline",
} as const;
